import React from "react";
import {inspectCycle, inspectionDay, inspectionWeek} from "../InspectionHeaderCreate";

/** 주기 유형별 강조 색 */
const CYCLE_COLOR = {
    "매주(week)": "#133E87",
    "매월(month)": "#133E87",
    "분기(quarter)": "#2d6a3e",
    "반기(half)": "#9a6200",
};

const DEFAULT_CYCLE_COLOR = CYCLE_COLOR["매월(month)"];

function resolveCycleLabel(value) {
    if (value == null || value === "") return "";
    return inspectCycle.find((each) => each.id === value)?.name ?? String(value);
}

function resolveWeekLabel(value) {
    if (value == null || value === "") return "";
    return inspectionWeek.find((each) => each.id === value)?.name ?? String(value);
}

function resolveDayLabel(value) {
    if (value == null || value === "") return "";
    return inspectionDay.find((each) => each.id === value)?.name ?? String(value);
}

function resolveDeadlineLabel(row) {
    if (row?.periodDateLimitText) return String(row.periodDateLimitText).trim();
    if (row?.periodDateLimit != null && row?.periodDateLimit !== "") {
        return `${row.periodDateLimit}일`;
    }
    return "";
}

function shortenCycleLabel(label) {
    return String(label).replace(/\s*\([^)]*\)\s*/g, "").trim() || label;
}

function buildCycleTooltip({cycle, week, day, deadline}) {
    return [cycle, week, day, deadline ? `기한 ${deadline}` : null].filter(Boolean).join(" · ");
}

function inspectionHeaderCycleRenderer({item}) {
    const row = item;
    if (!row?.inspectCycle) {
        return null;
    }

    const cycle = resolveCycleLabel(row.inspectCycle);
    const week = row.inspectCycle !== "매주(week)" ? resolveWeekLabel(row.week) : "";
    const day = resolveDayLabel(row.day);
    const deadline = resolveDeadlineLabel(row);
    const cycleShort = shortenCycleLabel(cycle);
    const cycleColor = CYCLE_COLOR[row.inspectCycle] ?? DEFAULT_CYCLE_COLOR;

    const details = [
        week || null,
        day || null,
        deadline ? `기한 ${deadline}` : null,
    ].filter(Boolean);

    const tooltip = buildCycleTooltip({cycle, week, day, deadline});

    return (
        <span
            className="inline-block min-w-0 max-w-full truncate text-[12px] leading-snug"
            title={tooltip}
        >
            <span className="font-semibold" style={{color: cycleColor}}>
                {cycleShort}
            </span>
            {details.length > 0 ? (
                <span className="text-[11px] font-normal text-[#64748b]">
                    {" "}
                    ({details.join(" · ")})
                </span>
            ) : null}
        </span>
    );
}

export {inspectionHeaderCycleRenderer};
